/* eslint-disable guard-for-in */
import { updateParseConversation } from '../../api/tickets';
import { decisionTreeCaseNotHandled } from '../index';
import { handleError } from 'services/ErrorService/ErrorService';
import { formatAssociatedOrderNumberForDisplay } from '../../util';
import {
  extractSelectedTicketIdFromState,
  extractSelectedTicketFromState,
  isSelectedTicketReviewTicket,
  extractCurrentDecisionTreePath,
  getRefundOnlyItems,
  getCancelAndRefundItems,
} from '../../extractFromState';
import { getOrderingSystem, getSelectedOrder, getShowConfirmationPagePaths } from '../../selectors/tools';
import { fetchCalculateInfo } from './CommonOrderActions';
import {
  CLEAR_ORDER_SEARCH_STATE,
  SELECT_ORDER,
  CLEAR_ORDERS,
  SELECT_ORDER_TASK,
  SELECT_ORDERING_SYSTEM,
  SELECT_SHOP_AND_CONFIG,
  SELECT_SEARCH_ORDER_SHOPS,
  SET_ORDERS,
  SET_SEARCH_ORDERS_ACTION,
  SHOW_ORDERS_SEARCH_ERROR,
  SET_SELECTED_ITEM,
  SET_SELECTED_NESTED_SUBITEMS,
  CLEAR_SELECTED_NESTED_SUBITEMS,
  SET_REFUNDS_COUNT,
  SET_RUTR_EVENTS,
  SET_RBI_CUSTOMER_ID,
  SET_RBI_LOYALTY_ID,
  SET_RBI_COUPONS_INFO,
  SET_SELECTED_RBI_ITEMS_FOR_REFUND,
  SET_SELECTED_RBI_ITEMS_FOR_COUPON,
  SET_RBI_APPROVED_REFUND_AMOUNT,
  SET_REFUND_AMOUNT_DETAILS,
  CLEAR_SELECTED_ITEMS,
  SET_LOADING_ORDER_ID,
  SET_SEARCH_ORDERS_QUERY,
  CLEAR_SNIPPET_TEXT,
  CLEAR_INVALID_SNIPPET_DATA,
  SET_RETURN_SHIPMENT_TRACKING_NUMBER,
  SET_RETURN_SHIPMENT_CARRIER,
  SET_RETURN_ITEMS,
  SET_REFUND_AMOUNT,
  SET_REFUND_AMOUNT_FORMATTED,
  SET_STORE_CREDIT_AMOUNT,
  SET_CANCELED_ITEMS,
  SET_SHOW_CONFIRMATION_PAGE,
  RESET_SHOW_CONFIRMATION_PAGE,
  SET_SUBSCRIPTION_FREQUENCY,
  SET_REFUNDS_ON_SHOPIFY_ORDER,
  SELECT_SHOP_NAME,
  SET_RETURN_NOTE,
  SET_RETURN_ORDER_ITEMS,
  SET_RETURN_REASON,
  SET_LAST_ORDER_IN_SELECTED_SUBBSCRIPTION,
  SET_AMAZON_ORDER_WARRANTY_TOTAL_YEARS,
  SET_CURRENCY_CODE,
  SET_ORDER_TOTAL,
  UPDATE_SELECTED_ORDER,
  ADD_CANCEL_AND_REFUND_ITEM,
  ADD_REFUND_ONLY_ITEM,
  ADD_CANCEL_ONLY_ITEM,
  ADD_DISCOUNT_ONLY_ITEM,
  CLEAR_CANCEL_REFUND_DISCOUNT_TREE_ITEMS,
  SET_ACTION_REASONS,
  SELECT_MULTI_DOMAIN,
  SELECT_SIMPLR_ORDER_MULTI_DOMAIN,
  SET_CUSTOMER_GROUPS,
  SET_SELECTED_CUSTOMER_GROUP_ID,
  SET_REFUND_SHIPPING_AMOUNT,
  ADD_EXTRA_LASTMILE_INFO,
  CLEAR_EXTRA_LASTMILE_INFO,
  SET_ORDER_SHIPPING_ADDRESS,
  SET_SHOPIFY_ORDER_SHIPPING_ADDRESS,
  SET_NUMBER_SUPPORT_TRANSACTIONS,
  SET_SELECTED_ALL_ITEMS,
  SET_SELECTED_ITEMS_QUANTITY,
  SET_ADDITIONAL_ORDER_DETAILS,
  SET_RBI_ASSIGNED_OFFERS,
  SET_SELECTED_CHEGG_BOOK_ISSUES_ORDER,
  SET_SELECTED_PRODUCT,
  SET_PRODUCTS_LIST,
  SET_PRODUCT_SEARCH_QUERY,
  SET_ORDER_TAGS,
  SET_DYNAMIC_ORDER_SEARCH_VALUE,
  SET_RBI_CUSTOMER_BIRTHDAY,
  SET_SELECTED_RBI_ITEMS_FOR_LOYALTY_POINTS,
} from '../../constants/ordersSearchActionTypes';
import { QUICK_ACTIONS } from '../../constants/decisionTree';
import { showErrorPopup } from '../../components/popups/ErrorPopup/ErrorPopup';
import { amazonGetOrderByNumber } from 'actions/tools/AmazonActions';
import { processAmazonOrderCancellation } from 'actions/tools/DecisionTree/AmazonActions';
import regex from '../../constants/regex';
import { setLoadingMessage } from 'actions';
import isEmpty from 'lodash/isEmpty';
import flatten from 'lodash/flatten';
import { v4 as uuid } from 'uuid';
import { processForRefundCalculation } from 'util/decisionTreeUtil';

// PLEASE NOTE: This file is for the old system-specific interfaces
// It is being deprecated. For common async actions, use CommonAsyncOrderActions

export const selectOrder = (order) => ({
  type: SELECT_ORDER,
  order,
});

export const setLoadingOrderId = (order_id) => ({
  type: SET_LOADING_ORDER_ID,
  order_id,
});

export const setDynamicOrderSearchValue = ({ paramName, paramValue }) => ({
  type: SET_DYNAMIC_ORDER_SEARCH_VALUE,
  paramName,
  paramValue,
});

export const setSearchOrdersAction = (action) => {
  return {
    type: SET_SEARCH_ORDERS_ACTION,
    action: action,
  };
};

export const setSelectedTicketOrderNumber = (orderNumber) => {
  return function (dispatch, getState) {
    const state = getState();
    const isReviewTicket = isSelectedTicketReviewTicket(state);

    if (isReviewTicket) {
      return;
    }

    const orderingSystem = getOrderingSystem(state);

    const displayedOrderNumber = formatAssociatedOrderNumberForDisplay(orderNumber);

    const selectedTicketId = extractSelectedTicketIdFromState(state);

    const updatedFields = {
      associatedOrderNumber: orderNumber,
      orderingSystem: orderingSystem,
    };

    return updateParseConversation(selectedTicketId, updatedFields)
      .then(() => {
        dispatch({
          type: 'UPDATE_TICKET_ORDER',
          ticketId: selectedTicketId,
          orderingSystem: orderingSystem,
          orderNumber: displayedOrderNumber,
          queueName: getState().ui.messages.selectedInboxTab,
        });
      })
      .catch((error) => {
        handleError({
          error,
          customMessage: 'Error setting selected ticket order number',
          showPopup: true,
        });
      });
  };
};

export const setSelectedTask = (selectedTask = null) => {
  return (dispatch) => {
    dispatch({
      type: SELECT_ORDER_TASK,
      task: selectedTask,
    });
  };
};

export const setOrderShippingAddress = (address) => ({
  type: SET_ORDER_SHIPPING_ADDRESS,
  payload: address,
});

export const setShopifyOrderShippingAddress = (address) => ({
  type: SET_SHOPIFY_ORDER_SHIPPING_ADDRESS,
  payload: address,
});

export const setSelectedMultiDomain = (domain) => ({
  type: SELECT_MULTI_DOMAIN,
  payload: domain,
});

export const setSimplrOrderSelectedMultiDomains = (domains) => ({
  type: SELECT_SIMPLR_ORDER_MULTI_DOMAIN,
  payload: domains,
});

export const selectOrderingSystem = (orderingSystem) => ({
  type: SELECT_ORDERING_SYSTEM,
  orderingSystem: orderingSystem,
});

export const setSearchOrdersQuery = (query) => ({
  type: SET_SEARCH_ORDERS_QUERY,
  query,
});

export const setReturnShipmentTrackingNumber = (number) => ({
  type: SET_RETURN_SHIPMENT_TRACKING_NUMBER,
  number,
});

export const setReturnShipmentCarrier = (carrier) => ({
  type: SET_RETURN_SHIPMENT_CARRIER,
  carrier,
});

export const setReturnedItems = (items) => ({
  type: SET_RETURN_ITEMS,
  items,
});

export const addCancelAndRefundItem = (item) => ({
  type: ADD_CANCEL_AND_REFUND_ITEM,
  item,
});

export const addRefundOnlyItem = (item) => ({
  type: ADD_REFUND_ONLY_ITEM,
  item,
});

export const addCancelOnlyItem = (item) => ({
  type: ADD_CANCEL_ONLY_ITEM,
  item,
});

export const addDiscountOnlyItem = (item) => ({
  type: ADD_DISCOUNT_ONLY_ITEM,
  item,
});

export const clearCancelRefundDiscountTreeItems = () => ({
  type: CLEAR_CANCEL_REFUND_DISCOUNT_TREE_ITEMS,
});

export const setActionReasons = (actionReasons) => ({
  type: SET_ACTION_REASONS,
  actionReasons,
});

export const setCanceledItems = (items) => ({
  type: SET_CANCELED_ITEMS,
  items,
});

export const setSubscriptionFrequency = (id, field, value) => ({
  type: SET_SUBSCRIPTION_FREQUENCY,
  id,
  field,
  value,
});

export const setRefundsOnShopifyOrder = (refunds) => ({
  type: SET_REFUNDS_ON_SHOPIFY_ORDER,
  refunds,
});

export const setRefundAmount = (amount) => ({
  type: SET_REFUND_AMOUNT,
  amount,
});

export const setRefundAmountFormatted = (amount) => ({
  type: SET_REFUND_AMOUNT_FORMATTED,
  amount,
});

export const setRefundShippingAmount = (amount) => ({
  type: SET_REFUND_SHIPPING_AMOUNT,
  amount,
});

export const setAmazonOrderWarrantyTotalYears = (totalYears) => ({
  type: SET_AMAZON_ORDER_WARRANTY_TOTAL_YEARS,
  totalYears,
});

export const setOrderTotal = (orderTotal) => ({
  type: SET_ORDER_TOTAL,
  orderTotal,
});

export const setCurrencyCode = (currencyCode) => ({
  type: SET_CURRENCY_CODE,
  currencyCode,
});

export const setStoreCreatAmount = (amount) => ({
  type: SET_STORE_CREDIT_AMOUNT,
  amount,
});

export const setReturnItems = (returnOrderItems) => ({
  type: SET_RETURN_ORDER_ITEMS,
  returnOrderItems,
});

export const setReturnReason = (returnReason) => ({
  type: SET_RETURN_REASON,
  returnReason,
});

export const resetShowConfirmationPage = () => ({
  type: RESET_SHOW_CONFIRMATION_PAGE,
});

export const setShowConfirmationPage = (value) => (dispatch, getState) => {
  const state = getState();
  const currentShowConfirmationForPaths = getShowConfirmationPagePaths(state);
  const currentPath = extractCurrentDecisionTreePath(getState());

  // if current path is already in showConfirmationPagePaths, don't add it second time
  if (currentShowConfirmationForPaths?.includes(currentPath)) {
    return;
  }

  return dispatch({
    type: SET_SHOW_CONFIRMATION_PAGE,
    path: currentPath,
    value,
  });
};

export const setReturnNote = (returnNote) => ({
  type: SET_RETURN_NOTE,
  returnNote,
});

export const setLastOrderInSelectedSubscription = (lastOrderInSelectedSubscription) => ({
  type: SET_LAST_ORDER_IN_SELECTED_SUBBSCRIPTION,
  lastOrderInSelectedSubscription,
});

// TODO: Convert thunks to regular actions
export const selectShopAndConfig = (shopName, config) => {
  return function (dispatch, getState) {
    dispatch({
      type: SELECT_SHOP_AND_CONFIG,
      shop: shopName,
      config: config,
    });
  };
};

export const selectSearchOrderShops = (searchOrderShops, searchOrderZendeskConfig) => {
  return function (dispatch) {
    dispatch({
      type: SELECT_SEARCH_ORDER_SHOPS,
      searchOrderShops,
      searchOrderZendeskConfig,
    });
  };
};

export const selectShopName = (shopName) => ({
  type: SELECT_SHOP_NAME,
  shopName,
});

export const deselectSearchOrderShops = () => {
  return function (dispatch, getState) {
    dispatch({
      type: SELECT_SEARCH_ORDER_SHOPS,
      searchOrderShops: null,
    });
  };
};

export const showSearchError = (error) => {
  return function (dispatch, getState) {
    dispatch({
      type: SHOW_ORDERS_SEARCH_ERROR,
      error: error,
    });
  };
};

export const clearOrderSearchState = () => ({
  type: CLEAR_ORDER_SEARCH_STATE,
});

export const setOrders = (orders) => ({
  type: SET_ORDERS,
  orders,
});

export const setCustomerGroups = (groups) => ({
  type: SET_CUSTOMER_GROUPS,
  groups,
});

export const setSelectedCustomerGroupId = (customerGroupId) => ({
  type: SET_SELECTED_CUSTOMER_GROUP_ID,
  customerGroupId,
});

export const updateSelectedOrder = (order) => ({
  type: UPDATE_SELECTED_ORDER,
  order,
});

export const clearOrders = () => ({
  type: CLEAR_ORDERS,
});

export const setSelectedItem = (itemId, value) => ({
  type: SET_SELECTED_ITEM,
  itemId,
  value,
});

export const setSelectedAllItems = (items) => ({
  type: SET_SELECTED_ALL_ITEMS,
  items,
});

export const setSelectedItemsQuantity = (itemId, quantity) => ({
  type: SET_SELECTED_ITEMS_QUANTITY,
  itemId,
  quantity,
});

export const setSelectedNestedSubItems = (itemId, selectedNestedSubItemsIds) => ({
  type: SET_SELECTED_NESTED_SUBITEMS,
  itemId,
  selectedNestedSubItemsIds,
});

export const clearSelectedNestedSubItems = (itemId) => ({
  type: CLEAR_SELECTED_NESTED_SUBITEMS,
  itemId,
});

export const setRbiRefundsCount = (refundsCountObj) => ({
  type: SET_REFUNDS_COUNT,
  refundsCountObj,
});

export const setRbiRutrEvents = (rutrEvents) => ({
  type: SET_RUTR_EVENTS,
  rutrEvents,
});

export const setRbiCustomerId = (customerId) => ({
  type: SET_RBI_CUSTOMER_ID,
  customerId,
});

export const setRbiCustomerBirthday = (rbiCustomerBirthday) => ({
  type: SET_RBI_CUSTOMER_BIRTHDAY,
  rbiCustomerBirthday,
});

export const setRbiLoyaltyId = (loyaltyId) => ({
  type: SET_RBI_LOYALTY_ID,
  loyaltyId,
});

export const setRbiCouponsInfo = (rbiCouponsInfo) => ({
  type: SET_RBI_COUPONS_INFO,
  rbiCouponsInfo,
});

export const setRbiAssignedOffers = (rbiAssignedOffers) => ({
  type: SET_RBI_ASSIGNED_OFFERS,
  rbiAssignedOffers,
});

export const setSelectedRbiItemsForCoupon = (selectedRbiItemsForCoupon) => ({
  type: SET_SELECTED_RBI_ITEMS_FOR_COUPON,
  selectedRbiItemsForCoupon,
});

export const setSelectedRbiItemsForLoyaltyPoints = (selectedRbiItemsForLoyaltyPoints) => ({
  type: SET_SELECTED_RBI_ITEMS_FOR_LOYALTY_POINTS,
  selectedRbiItemsForLoyaltyPoints,
});

export const setSelectedRbiItemsForRefund = (selectedRbiItemsForRefund) => ({
  type: SET_SELECTED_RBI_ITEMS_FOR_REFUND,
  selectedRbiItemsForRefund,
});

export const setRbiApprovedRefundAmount = (amount) => ({
  type: SET_RBI_APPROVED_REFUND_AMOUNT,
  amount,
});

export const setSelectedCheggBookIssuesOrder = (selectedCheggBookIssuesOrder) => ({
  type: SET_SELECTED_CHEGG_BOOK_ISSUES_ORDER,
  selectedCheggBookIssuesOrder,
});

export const setNumberSupportTransactions = (numberCustomerSupportTransactions) => ({
  type: SET_NUMBER_SUPPORT_TRANSACTIONS,
  numberCustomerSupportTransactions,
});

export const setRefundAmountDetails = (refundAmountDetails) => ({
  type: SET_REFUND_AMOUNT_DETAILS,
  refundAmountDetails,
});

export const clearSelectedItems = () => ({
  type: CLEAR_SELECTED_ITEMS,
});

export const clearInvalidSnippetData = () => ({
  type: CLEAR_INVALID_SNIPPET_DATA,
});

export const clearSnippetText = () => ({
  type: CLEAR_SNIPPET_TEXT,
});

export const addExtraLastMileInfo = (extraLastMileInfo) => ({
  type: ADD_EXTRA_LASTMILE_INFO,
  extraLastMileInfo,
});

export const clearExtraLastMileInfo = () => ({
  type: CLEAR_EXTRA_LASTMILE_INFO,
});

const _quickActionCancelAmazonOrder = () => async (dispatch, getState) => {
  const state = getState();
  const { simplrAccountPtrId: simplrAccountId } = extractSelectedTicketFromState(state);
  const orderNumbers = findAmazonOrderNumbersInConversation(getState);

  if (!orderNumbers.length) {
    return showErrorPopup(`Couldn't find order number. Please handle the request manually`, 'Error');
  }

  // not handling multiple cancellation requests
  if (orderNumbers.length > 1) {
    return dispatch(decisionTreeCaseNotHandled('Not handling multiple orders. Please escalate the ticket'));
  }

  const orderNumber = orderNumbers[0];

  try {
    /*  API call to get order information
     *  on success, selects the order in redux
     */
    dispatch(setLoadingMessage(`Step 1: Getting information for ${orderNumber} order number`));
    await dispatch(amazonGetOrderByNumber(simplrAccountId, orderNumber, true));

    /*  If API call ^ failed, selected order is undefined
     *  will throw error to prevent double error popup
     */
    const selectedOrder = getSelectedOrder(getState());
    if (isEmpty(selectedOrder)) {
      throw new Error('Error getting order information');
    }

    /*  processAmazonOrderCancellation() process selectedOrder from the store
     *  generates final edge to render
     */
    dispatch(setLoadingMessage('Step 2: Processing order data'));
    await dispatch(processAmazonOrderCancellation(true, orderNumber));
  } catch (error) {
    return handleError({
      error,
      customMessage: 'Something went wrong. Please handle the request manually',
      showPopup: true,
      popupOnly: true,
    });
  }
};

export const findAmazonOrderNumbersInConversation = (getState) => {
  const { allMessages, ...conversation } = getState().conversation;
  const orderNumbers = allMessages.map((messageId) => {
    const { subject, messageBody } = conversation[messageId];
    const orderNumbersInSubject = subject.match(regex.amazonOrderNumber) || [];
    const orderNumbersInBody = messageBody.match(regex.amazonOrderNumber) || [];

    return [...orderNumbersInSubject, ...orderNumbersInBody];
  });

  return [...new Set(flatten(orderNumbers) || [])];
};

export const showQuickActionButton = (quickActionType) => (_, getState) => {
  switch (quickActionType) {
    case QUICK_ACTIONS.CANCEL_AMAZON_ORDER:
      const orderNumbers = findAmazonOrderNumbersInConversation(getState);

      return !!orderNumbers.length;
    default:
      return false;
  }
};

export const runQuickAction = (quickActionType) => {
  switch (quickActionType) {
    case QUICK_ACTIONS.CANCEL_AMAZON_ORDER:
      return _quickActionCancelAmazonOrder();
    default:
      handleError(`No quick action found for quickActionType: ${quickActionType}`);
  }
};

export const _getRefundForCancelRefundFlow = (orderId) => async (dispatch, getState) => {
  const state = getState();
  const refundOnlyItems = getRefundOnlyItems(state);
  const cancelAndRefundItems = getCancelAndRefundItems(state);
  const orderingSystem = getOrderingSystem(state);
  const allItems = [...refundOnlyItems, ...cancelAndRefundItems];
  const refundItems = processForRefundCalculation(allItems, orderingSystem);

  const options = {
    orderId: String(orderId),
    uniqueRequestUuid: uuid(),
    refundItems,
  };

  const response = await dispatch(fetchCalculateInfo(options));
  const { total, currency } = response;

  return {
    currency,
    total: total && total.toFixed(2),
  };
};

export const setAdditionalOrderDetails = (additionalOrderDetails) => ({
  type: SET_ADDITIONAL_ORDER_DETAILS,
  additionalOrderDetails,
});

export const setSelectedProduct = (selectedProduct) => ({
  type: SET_SELECTED_PRODUCT,
  selectedProduct,
});

export const setProductsList = (productsList) => ({
  type: SET_PRODUCTS_LIST,
  productsList,
});

export const setProductSearchQuery = (productQuery) => ({
  type: SET_PRODUCT_SEARCH_QUERY,
  productQuery,
});

export const setOrderTags = (orderTags) => ({
  type: SET_ORDER_TAGS,
  orderTags,
});
